// extracted by mini-css-extract-plugin
export default {"head-schedule-ruleset__container":"styles_head-schedule-ruleset__container__Q3Miz","head-schedule-ruleset__title":"styles_head-schedule-ruleset__title__PGd0C"};